import React from 'react'
import ReservationInitialize from '../../ReservationInitialize'
import {ReservationPop} from './ReservationPop'

export const ReservationPopMain = () => {
  return (
    <ReservationInitialize>
      <ReservationPop />
    </ReservationInitialize>
  )
}
